import { MDSDialogSlotName } from "@/mds/components/overlays/dialog";
import {
  getPaywallDialogWidth,
  PaywallContent,
  PaywallHeader,
  PaywallModalDialog,
  PaywallPlanAction,
  type PaywallPlanActionProps,
  PaywallPlanCard,
  type PaywallPlanCardDefinition,
  PaywallPlansGrid,
  PaywallSubtitle,
  PaywallTitle,
} from "@/components/modal/paywall/paywall-modal-components";

export type UpsellPlanActions = Partial<Record<string, PaywallPlanActionProps>>;

export interface UpsellModalViewProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  planActions: UpsellPlanActions;
  planCards: PaywallPlanCardDefinition[];
}

export const UpsellModalView = ({
  isOpen,
  onClose,
  title,
  subtitle,
  planActions,
  planCards,
}: UpsellModalViewProps) => (
  <PaywallModalDialog
    isOpen={isOpen}
    handleClose={onClose}
    dialogWidth={getPaywallDialogWidth(planCards.length)}
  >
    <PaywallHeader slot={MDSDialogSlotName.Header}>
      <PaywallTitle>{title}</PaywallTitle>
    </PaywallHeader>

    <PaywallContent slot={MDSDialogSlotName.Content}>
      <PaywallSubtitle>{subtitle}</PaywallSubtitle>

      <PaywallPlansGrid columnCount={planCards.length} stretchCards>
        {planCards.map(planCard => {
          const action = planActions[planCard.id];

          return (
            <PaywallPlanCard
              key={planCard.id}
              planCard={planCard}
              action={action ? <PaywallPlanAction {...action} /> : undefined}
            />
          );
        })}
      </PaywallPlansGrid>
    </PaywallContent>
  </PaywallModalDialog>
);
